/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

interface Headers {
  'content-type': string;
  'x-auth-token'?: string;
}

// Minimal headers for auth requests

const convertHeadersToAxiosHeaders = (headers?: Headers): Record<string, string> => {
  const axiosHeaders: Record<string, string> = {};
  if (headers) {
    for (const [key, value] of Object.entries(headers)) {
      axiosHeaders[key] = value;
    }
  }
  return axiosHeaders;
};

async function request(method: string, url: string, body?: any, header?: Headers) {
  const token = localStorage.getItem('token');
  const headers: Record<string, string> = convertHeadersToAxiosHeaders({
    'content-type': 'application/json',
    ...(header || {}),
  });
  
  // Handle FormData differently
  if (body instanceof FormData) {
    // Remove content-type for FormData to let browser set it with boundary
    delete headers['content-type'];
  }
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    headers['x-auth-token'] = token; // Keep both for compatibility
  }
  
  const res = await fetch(url, {
    method,
    headers,
    body: body instanceof FormData ? body : (body ? JSON.stringify(body) : undefined),
  });
  const status = res.status;
  const statusText = res.statusText;
  let data: any = null;
  try {
    data = await res.json();
  } catch (_) {
    data = null;
  }
  if (status >= 200 && status < 300) {
    return { status, statusText, data };
  }
  // mimic axios error.response
  throw { status, statusText, data };
}

export const backendServices = {
  post: (url: string, params: any, header?: Headers) => request('POST', url, params, header),
  get: (url: string, header?: Headers) => request('GET', url, undefined, header),
  put: (url: string, params: any, header?: Headers) => request('PUT', url, params, header),
  patch: (url: string, params: any, header?: Headers) => request('PATCH', url, params, header),
  delete: (url: string, header?: Headers) => request('DELETE', url, undefined, header),
};
